import React, { useState, useRef, useMemo, useCallback } from 'react'
import Button from '../button'
import { isAdmin } from '../../common/roles'

import S from './styled'

const Status = ({ title, name, value, statuses, onChange, compact, noActions, role, disabled }) => {

  const [menuOpened, setMenuOpened] = useState(false)

  const menuEl = useRef(null)

  const handleClickOutside = useMemo(() => {
    return event => {
      if (menuEl.current && !menuEl.current.contains(event.target)) {
        document.removeEventListener('mousedown', handleClickOutside)
        setMenuOpened(false)
      }
    }
  }, [])

  const hideMenu = useCallback(() => {
    document.removeEventListener('mousedown', handleClickOutside)
    setMenuOpened(false)
  }, [handleClickOutside])

  const showMenu = useCallback(() => {
    document.addEventListener('mousedown', handleClickOutside)
    setMenuOpened(true)
  }, [handleClickOutside])

  const handleAdd = useCallback(value => {
    hideMenu()
    onChange({
      target: {
        name,
        value,
      },
    })
  }, [hideMenu, name, onChange])

  const valuesToRender = Reflect.ownKeys(statuses)
    .filter(id => {
      if (!role) {
        return id
      }
      return statuses[id].adminOnly && isAdmin(role) ? id : statuses[id].adminOnly ? null : id
    }).filter(Boolean).map(id => ({
      id,
      name: statuses[id].name,
    })).filter(status => status.id !== value)

  const statusInfo = statuses[value] || statuses[Reflect.ownKeys(statuses)[0]]
  return (
    <S.Status compact={compact} noActions={noActions}>
      {title && <label>{title}</label>}
      <Button {...{
        blue: statusInfo.blue,
        green: statusInfo.green,
        gray: statusInfo.gray,
        orange: statusInfo.orange,
      }} onClick={noActions || disabled ? null : showMenu}>{statusInfo.name}</Button>
      {menuOpened && (
        <S.Menu ref={menuEl}>
          {
            valuesToRender.map(status => (
              <S.MenuItem key={`menu-item-${status.id}`} onClick={() => handleAdd(status.id)}>
                {status.name}
              </S.MenuItem>
            ))
          }
        </S.Menu>
      )}
    </S.Status>
  )
}

export default Status
